export const environment = {
  production: false,
  environmentName: 'qa',

  domainName: 'cordelllaw',
  tenantId: 'a3a79d12-cac2-4d4d-82a4-22eeb4946eda',
  appClientId: '55813a5e-e994-465f-a1fc-5fc8ebff2eeb',
  appIdUri: 'api://lexicon-surveys-qa02',

  apiEndpointUrl: 'https://surveysapiqa.lexiconservices.com',

  useLogRocket: false,

  // Search debounce time in milliseconds
  searchDebounceTime: 2000
};
